
import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import { fetchAllUsersThunk, fetchUserDetails } from './Thunk/LoginThunk';
const initialState = {
  loginUserDetails: {},
  getAllClients: [],
  userStatus: false,
  allUsers: [],
};

const loginUserSlice = createSlice({
  name: 'loginUser',
  initialState,
  reducers: {
    setLoginUserDetails: (state, action) => {
      state.loginUserDetails = action.payload;
    },
    getAllClientsData: (state, action) => {
      state.getAllClients = action.payload;
    },
    setUserStatus: (state, action) => {
      state.userStatus = action.payload;
    },
    setPunchInStatus(state, action){
      state.punchinStatus=action.payload;
    },
    setAllUsers: (state, action) => {
      state.allUsers = action.payload;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(fetchUserDetails.fulfilled, (state, action) => {
        state.loginUserDetails = action.payload;
        state.userStatus = true;
      })
      .addCase(fetchAllUsersThunk.fulfilled, (state, action,) => {
        state.loading = false;
        state.allUsers = action.payload;
        state.userStatus = true;
      });
  },
});

export const { setLoginUserDetails, setUserStatus, setPunchInStatus,setAllUsers, getAllClientsData } = loginUserSlice.actions;
export default loginUserSlice.reducer;


